<template>
  <div class="mb-4">
    <h5>{{ p_surveyItem.surveyItemName }}</h5>
    <a
      href="javascript:undefined"
      class="qa-taglist f-14"
      :class="surveyItemValue.isSelected ? 'active' : ''"
      @click.prevent="handleClick(surveyItemValue)"
      :key="surveyItemValue.v"
      v-for="surveyItemValue in surveyItemValues"
    >
      {{ surveyItemValue.v }}
    </a>
    <div v-show="false">
      <input
        type="checkbox"
        :name="p_surveyItem.surveyItemKey"
        :value="surveyItemValue.v"
        v-model="content"
        :key="surveyItemValue.v"
        v-for="surveyItemValue in surveyItemValues"
      />
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import _ from 'lodash';

export default {
  name: 'SurveyItemCheckbox',

  props: {
    p_surveyItem: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      surveyItemValues: [],

      content: [],
    };
  },

  computed: {
    c_content() {
      let surveyItemValues = _.filter(
        this.surveyItemValues,
        (surveyItemValue) => surveyItemValue.isSelected
      );
      surveyItemValues = _.map(
        surveyItemValues,
        (surveyItemValue) => surveyItemValue.v
      );
      return surveyItemValues;
    },
  },

  methods: {
    ...mapMutations('Mixins/Survey', {
      mm_UPDATE_SURVEY_ITEM: 'UPDATE_SURVEY_ITEM',
    }),

    handleClick(surveyItemValue) {
      const newSurveyItemValue = {
        ...surveyItemValue,
        isSelected: !surveyItemValue.isSelected,
      };
      this.surveyItemValues.splice(surveyItemValue.idx, 1, newSurveyItemValue);
      this.content = this.c_content;
      this.mm_UPDATE_SURVEY_ITEM({
        ...this.p_surveyItem,
        i_isReady: this.content.length > 0,
      });
    },
  },

  created() {
    let surveyItemValues = _.split(this.p_surveyItem.surveyItemValues, '|');
    surveyItemValues = _.map(surveyItemValues, (surveyItemValue, idx) => ({
      v: surveyItemValue,
      isSelected: false,
      idx,
    }));
    this.surveyItemValues = surveyItemValues;
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
